/* Hushwell v6 — buy box, sticky bar, gallery dots, pop-up. No dependencies. */
(function () {
  'use strict';

  function qs(el, s) { return el.querySelector(s); }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

  class HwBuybox extends HTMLElement {
    connectedCallback() {
      this.btn = qs(this, '[data-hw-atc]');
      this.err = qs(this, '[data-hw-err]');
      var self = this;
      qsa(this, '.hw-opt__radio').forEach(function (r) {
        r.addEventListener('change', function () { self.update(); });
      });
      qsa(this, '.hw-pt input').forEach(function (r) {
        r.addEventListener('change', function () { self.update(); });
      });
      qsa(this, '.hw-consent__cb').forEach(function (c) {
        c.addEventListener('change', function () { self.update(); });
      });
      this.btn.addEventListener('click', function () { self.add(); });
      this.update();
    }
    tier() { return qs(this, '.hw-opt__radio:checked') || qs(this, '.hw-opt__radio'); }
    state() {
      var r = this.tier();
      var opt = r.closest('.hw-opt');
      var sub = false, consent = true;
      if (r.dataset.sub === '1') {
        var pt = qs(opt, '.hw-pt input:checked');
        sub = !!(pt && pt.value === 'sub');
        if (sub) { var cb = qs(opt, '.hw-consent__cb'); consent = !!(cb && cb.checked); }
      }
      return { r: r, opt: opt, qty: parseInt(r.dataset.qty, 10) || 1, sub: sub, consent: consent };
    }
    update() {
      var st = this.state();
      qsa(this, '.hw-opt').forEach(function (o) { o.classList.toggle('is-sel', o === st.opt); });
      qsa(this, '.hw-pt label').forEach(function (l) { var i = qs(l, 'input'); l.classList.toggle('is-on', !!(i && i.checked)); });
      qsa(this, '.hw-opt').forEach(function (o) {
        var pt = qs(o, '.hw-pt input:checked');
        var box = qs(o, '.hw-sub');
        if (box) box.classList.toggle('is-on', !!(pt && pt.value === 'sub'));
      });
      this.btn.textContent = st.sub ? (st.r.dataset.subbtn || 'Subscribe') : (st.r.dataset.btn || 'Add to cart');
      this.btn.disabled = st.sub && !st.consent;
      this.err.classList.remove('is-on');
      document.dispatchEvent(new CustomEvent('hw:tier', { detail: { name: st.r.dataset.name, price: st.sub ? st.r.dataset.subprice : st.r.dataset.price, btn: this.btn.textContent } }));
    }
    fail(msg) { this.err.textContent = msg; this.err.classList.add('is-on'); }
    add() {
      var st = this.state();
      var self = this;
      if (st.sub && !st.consent) { this.fail('Please tick the box to agree to the subscription terms.'); return; }
      var item = { id: parseInt(st.r.dataset.variant || this.dataset.variant, 10), quantity: st.qty };
      if (st.sub) {
        var plan = st.r.dataset.plan || this.dataset.plan;
        if (!plan) { this.fail('Subscription isn’t switched on yet. Choose one-time for now.'); return; }
        item.selling_plan = parseInt(plan, 10);
      }
      var drawer = document.querySelector('cart-drawer');
      var body = { items: [item] };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      this.btn.classList.add('is-busy'); this.btn.disabled = true;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (res) { return res.json().then(function (j) { return { ok: res.ok, j: j }; }); })
        .then(function (r) {
          self.btn.classList.remove('is-busy'); self.btn.disabled = false;
          if (!r.ok || r.j.status) { self.fail((r.j && (r.j.description || r.j.message)) || 'Something went wrong. Please try again.'); return; }
          if (drawer && r.j.sections) {
            var parsed = r.j; parsed.id = item.id;
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(parsed);
          } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
        })
        .catch(function () { self.btn.classList.remove('is-busy'); self.btn.disabled = false; self.fail('Connection problem. Please try again.'); });
    }
  }
  if (!customElements.get('hw-buybox')) customElements.define('hw-buybox', HwBuybox);

  /* Sticky bar: visible on mobile when no buy box is on screen */
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.querySelector('[data-hw-sticky]');
    var boxes = qsa(document, 'hw-buybox');
    if (bar && boxes.length && 'IntersectionObserver' in window) {
      var vis = new Map();
      var hero = document.querySelector('.hw-hero');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { vis.set(e.target, e.isIntersecting); });
        var anyBox = false; vis.forEach(function (v) { if (v) anyBox = true; });
        var past = hero ? hero.getBoundingClientRect().bottom < 0 : true;
        bar.classList.toggle('is-on', !anyBox && past);
      });
      boxes.forEach(function (b) { io.observe(b); });
      window.addEventListener('scroll', function () {
        var anyBox = false; vis.forEach(function (v) { if (v) anyBox = true; });
        var past = hero ? hero.getBoundingClientRect().bottom < 0 : true;
        bar.classList.toggle('is-on', !anyBox && past);
      }, { passive: true });
      var label = qs(bar, '[data-hw-sticky-name]'), price = qs(bar, '[data-hw-sticky-price]');
      document.addEventListener('hw:tier', function (e) { if (label) label.textContent = e.detail.name; if (price) price.textContent = e.detail.price; });
      qs(bar, 'button').addEventListener('click', function () { boxes[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); });
    }

    /* Gallery dots */
    qsa(document, '.hw-gallery').forEach(function (g) {
      var t = qs(g, '.hw-gallery__track'), dots = qsa(g, '.hw-gallery__dots span');
      if (!t || dots.length < 2) return;
      t.addEventListener('scroll', function () {
        var i = Math.round(t.scrollLeft / t.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); });
      }, { passive: true });
    });

    /* Pop-up: once per 14 days, after delay or 45% scroll; never over the open cart */
    var pop = document.querySelector('[data-hw-pop]');
    if (pop) {
      var KEY = 'hw_pop_seen';
      var seen = false;
      try { var v = localStorage.getItem(KEY); seen = v && (Date.now() - parseInt(v, 10) < 14 * 864e5); } catch (e) {}
      if (pop.dataset.posted === '1') { pop.classList.add('is-on'); seen = true; }
      var shown = false;
      function show() {
        if (shown || seen) return;
        if (document.querySelector('cart-drawer.active')) return;
        shown = true; pop.classList.add('is-on');
        try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
      }
      function hide() { pop.classList.remove('is-on'); }
      var delay = (parseInt(pop.dataset.delay, 10) || 20) * 1000;
      if (!seen) {
        setTimeout(show, delay);
        window.addEventListener('scroll', function () {
          var h = document.documentElement;
          if ((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.45) show();
        }, { passive: true });
      }
      qsa(pop, '[data-hw-pop-close]').forEach(function (b) { b.addEventListener('click', hide); });
      pop.addEventListener('click', function (e) { if (e.target === pop) hide(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    }
  });

  /* Cart ladder: bottle-count rungs + one growing "You're saving $X" line, injected into Dawn's cart drawer.
     Bottles = quantity x units (bundle products from the config, or the number a variant title starts with).
     Also locks quantity on subscription lines. */
  function money(c) { var n = c / 100; return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
  var hwBusy = false;
  function hwLadder() {
    var cfg = window.HW_CART;
    var box = document.getElementById('CartDrawer-CartItems');
    if (!cfg || !box || hwBusy || box.querySelector('.hw-ladder') || !box.querySelector('.cart-items')) return;
    hwBusy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      hwBusy = false;
      box = document.getElementById('CartDrawer-CartItems');
      if (!box || box.querySelector('.hw-ladder')) return;
      cart.items.forEach(function (it, i) {
        if (!it.selling_plan_allocation) return;
        var row = document.getElementById('CartDrawer-Item-' + (i + 1));
        if (!row) return;
        qsa(row, '.quantity__button').forEach(function (b) { b.disabled = true; });
        qsa(row, 'input.quantity__input').forEach(function (inp) { inp.readOnly = true; });
      });
      if (!cfg.enabled) return;
      var pick = null;
      cfg.offers.forEach(function (o) {
        var n = 0, paid = 0, sub = false, lines = 0, key = null;
        cart.items.forEach(function (it) {
          var bu = o.bundles && o.bundles[it.handle];
          if (it.handle !== o.handle && !bu) return;
          var u = bu ? bu.units : (parseInt(String(it.variant_title || '').split(' ')[0], 10) || 1);
          n += it.quantity * u; paid += it.final_line_price; lines += 1; key = it.key;
          if (it.selling_plan_allocation) sub = true;
        });
        if (n > 0 && !pick) pick = { o: o, n: n, paid: paid, sub: sub, lines: lines, key: key };
      });
      if (!pick) return;
      var msg = '', next = null, max = 1;
      pick.o.rungs.forEach(function (r) {
        if (r[0] > max) max = r[0];
        if (r[0] <= pick.n) msg = r[1]; else if (!next) next = r;
      });
      var pct = Math.min(100, Math.round(pick.n * 100 / max));
      var save = pick.o.single * pick.n - pick.paid;
      var html = '<div class="hw hw-ladder">' + (msg ? '<div>' + esc(msg) + '</div>' : '') +
        '<div class="hw-ladder__bar" aria-hidden="true"><span style="width:' + pct + '%"></span></div>' +
        (save > 0 ? '<div class="hw-ladder__save">You’re saving ' + money(save) + '</div>' : '');
      if (next && next[2] && !pick.sub) {
        var diff = next[0] - pick.n;
        var bundle = pick.o.variants && pick.o.variants[next[0]];
        if (!bundle && pick.o.bundles) { for (var hk in pick.o.bundles) { if (pick.o.bundles[hk] && pick.o.bundles[hk].units === next[0]) bundle = pick.o.bundles[hk].variant; } }
        var attrs = bundle && pick.lines === 1
          ? 'data-variant="' + bundle + '" data-qty="1" data-swap="' + esc(pick.key) + '"'
          : 'data-variant="' + pick.o.single_id + '" data-qty="' + diff + '"';
        html += '<button type="button" class="hw-ladder__add" data-hw-ladder-add ' + attrs + '>' + esc(next[2].replace('{n}', diff)) + '</button>';
      }
      html += '</div>';
      box.insertAdjacentHTML('afterbegin', html);
    }).catch(function () { hwBusy = false; });
  }
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    hwLadder();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(hwLadder, 60); }).observe(drawer, { childList: true, subtree: true });
  });

  /* Cart ladder buttons: swap the line for the bigger bundle, or add single bottles */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hw-ladder-add]');
    if (!b) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(b.dataset.variant, 10), quantity: parseInt(b.dataset.qty, 10) || 1 }] };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
    b.disabled = true;
    var swap = b.dataset.swap ? fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.swap, quantity: 0 }) }) : Promise.resolve();
    swap.then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (drawer && j.sections) { j.id = body.items[0].id; drawer.renderContents(j); } else { window.location.reload(); } })
      .catch(function () { window.location.reload(); });
  });
})();
